<mat-toolbar class="matero-toolbar">
  <app-branding *ngIf="showBranding"></app-branding>
  <app-topmenu class="topmenu"></app-topmenu>
  <span class="m-auto"></span>
  <button
    id="screen-toggle"
    class="matero-toolbar-button"
    mat-mini-fab
    (click)="toggleFullscreen()"
  >
    <mat-icon *ngIf="!isFullScreen">fullscreen</mat-icon>
    <mat-icon *ngIf="isFullScreen">close_fullscreen</mat-icon>
  </button>
  <app-user></app-user>
</mat-toolbar>
